<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },


}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

html,
body {
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none !important;
  height: 100vh;



  -webkit-user-select: auto;

  /* height: 100%; */
  /* 瀑布流高度不能为100% */
}

* {

  margin: 0;
  padding: 0;
  box-sizing: border-box;

}

.oneText {
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.twoText {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.row {
  display: flex;
  align-items: center;
}

div {
  box-sizing: border-box;
  flex-direction: row;
}</style>



// WEBPACK FOOTER //
// src/App.vue